import React from 'react';
import { connect } from 'react-redux';

import LANGUAGES_CONTROLLER from '../../../controllers/languages';
import Logger, { LOG_LEVELS } from '../../../utils/logger';
import _ from 'underscore';
import { SSelect } from '@avalara/skylab-sdk/react';

const log = new Logger('SINGLE_COUNTRY_SELECTOR', LOG_LEVELS.ERROR);

export class SingleCountrySelector extends React.Component {

  onSelectionChange(event) {
    const fieldName = this.props.fieldName;
    log.debug('onSelectionChange(): %s, ', fieldName, event);
    log.debug('onSelectionChange(): %s, oldValue: %s, newValue: %s  ', fieldName, this.props.selectedCountryCode, event.detail.item.value);
    let selection = {};
    selection[fieldName] = event.detail.item.value !== '' ? event.detail.item.value : undefined;
    this.props.selectionHandler(selection);
  }

  render() {
    log.debug('render(): ', this.props);
    //check for current valid licences
    let filteredCountryList = this.props.countryList || [];
    if (this.props.disableFilterByLicence !== true && this.props.licences && this.props.countryList) {
      const today = new Date();
      const validLicences = this.props.licences.filter(
        (licence) =>
          ((this.props.extraProps && this.props.extraProps.applyLicencesCheck !== undefined && this.props.extraProps.applyLicencesCheck === false) ||
            (new Date(licence.validFrom) <= today && new Date(licence.validTo) >= today)) &&
          licence.active === true
      );
      const featureCodes = validLicences.map((licence) => licence.featureCode);
      filteredCountryList = this.props.countryList.filter((f) => featureCodes.includes(f.countryCode));
    }

    const allText =
      typeof this.props.selectValueLanguageStringKey === 'string'
        ? LANGUAGES_CONTROLLER.format(this.props.languages, this.props.selectValueLanguageStringKey)
        : LANGUAGES_CONTROLLER.format(this.props.languages, 'global_SelectCountry');

    let options = filteredCountryList.map((country, key) => {
      const label = this.props.hideCountryCode ? country.countryName : `${country.countryName} (${country.countryCode})`;
      return { value: country.countryCode, label: label, selected: this.props.selectedCountryCode === country.countryCode };
    }, this);

    const allOptions = [{ label: allText, value: '' }, ...options];
    const disabled = this.props.extraProps.disabled ? true : false;
    const className = this.props.extraProps.className;

    return (
      <div data-test="component-single-country-selector" className={className}>
        <SSelect
          inputId="single-country-select"
          value={this.props.selectedCountryCode}
          name="countries"
          onS-select={this.onSelectionChange.bind(this)}
          optionsList={allOptions}
          multiple={false}
          showSelectionCount={false}
          disabled={disabled}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages,
    licences: state.authentication && state.authentication.licences,
  };
}


SingleCountrySelector.defaultProps = {
  extraProps: {},
  disableFilterByLicence: false,
  today: new Date(),
};

export default connect(mapStateToProps)(SingleCountrySelector);
